
export default {
  name: 'BaseFormActionsDefault',
  props: {
    valid: {
      type: Boolean,
      required: true,
    },

    cancel: {
      type: Boolean,
      default: false,
    },

    cancelText: {
      type: String,
      default: 'Cancel',
    },

    submitText: {
      type: String,
      default: 'Save',
    },
  },
}
